import { BASE_URL } from "../commonUrls";

function authHeaders() {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  return { Authorization: `Bearer ${auth.token || ""}` };
}

async function downloadFile(url, filename) {
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) throw new Error("Export failed: " + res.status);
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(a.href);
}

export const exportNotes        = () => downloadFile(`${BASE_URL}/export/notes`, `lifeos-notes-${today()}.md`);
export const exportPlanner      = () => downloadFile(`${BASE_URL}/export/planner`, `lifeos-planner-${today()}.csv`);
export const exportTransactions = () => downloadFile(`${BASE_URL}/export/transactions`, `lifeos-transactions-${today()}.csv`);

function today() {
  return new Date().toISOString().slice(0, 10);
}
